//#region Libraries
//#endregion
//#region Styles
import { ContainerParts } from "components/styles";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import Part2 from "./components/Part2/Part2";
//#endregion

const Step1 = ({
    form, errors, 
    errorTexts,
    changeForm, 
    dataRelatedToForm: {
        allDays,
        allAdvisers
    }
}) => {
    const changeFieldPart1 = (field, value, errorValue) => {
        changeForm("part1", field, value, errorValue);
    }
    const changeFieldPart2 = (field, value, errorValue) => {
        changeForm("part2", field, value, errorValue);
    }
    return (
        <ContainerParts>
            <Part1 
                allAdvisers={allAdvisers}
                form={form.part1}
                changeField={changeFieldPart1}
                errors={errors.part1}
                errorTexts={errorTexts}/>
            <Part2
                allDays={allDays}
                form={form.part2}
                changeField={changeFieldPart2}
                errors={errors.part2}/>
        </ContainerParts>
    );
}

export default Step1;